import { ReactComponent as Close } from "../../img/Close.svg";
import { ReactComponent as Sparkle } from "../../img/Sparkle.svg";

const HARDCODED_NEXT_BILLING_DATE = "April 1, 2026";

interface EnrollBrilliantMaxModalProps {
  closeEnrollBrilliantMaxModal: () => void;
  homeName: string;
  paymentMethod?: string;
}

const EnrollBrilliantMaxModal: React.FC<EnrollBrilliantMaxModalProps> = ({
  closeEnrollBrilliantMaxModal,
  homeName,
  paymentMethod,
}) => {
  return (
    <div className="popup-background">
      <div className="modal-create-container">
        <div className="modal-header">
          <div className="modal-title-container">
            <Sparkle className="cancel-bmx-modal-sparkle" title="Sparkle" />
            <div className="unit-title">
              Enroll in Brilliant Max:{" "}
              <span className="cancel-bmx-modal-title-name">{homeName}</span>
            </div>
          </div>
          <Close
            className="modal-header-img"
            onClick={closeEnrollBrilliantMaxModal}
            title="Close modal"
          />
        </div>

        <div className="modal-create-body">
          <div className="cancel-bmx-modal-info-card">
            Once confirmed, the following home will have access to Brilliant
            Max. You will be billed $7 for this home&apos;s subscription on a
            monthly basis starting today, if the subscription remains active.
          </div>

          <div
            className={
              paymentMethod
                ? "enroll-bmx-modal-table-3col"
                : "enroll-bmx-modal-table-2col"
            }
          >
            <span className="enroll-bmx-modal-table-header sub-heading">
              Home to be Subscribed
            </span>
            {paymentMethod && (
              <span className="enroll-bmx-modal-table-header sub-heading">
                Payment Method
              </span>
            )}
            <span className="enroll-bmx-modal-table-header sub-heading">
              Next Billing Date
            </span>

            <span className="enroll-bmx-modal-table-value tool-tip">
              {homeName}
            </span>
            {paymentMethod && (
              <span className="enroll-bmx-modal-table-value tool-tip">
                {paymentMethod}
                <button
                  className="enroll-bmx-modal-table-edit-link"
                  type="button"
                  onClick={() => {}}
                >
                  Edit
                </button>
              </span>
            )}
            <span className="enroll-bmx-modal-table-date tool-tip">
              {HARDCODED_NEXT_BILLING_DATE}
            </span>
          </div>

          <div className="cancel-bmx-modal-actions">
            <button
              className="tertiary-btn-small"
              type="button"
              onClick={closeEnrollBrilliantMaxModal}
            >
              Go Back
            </button>
            <button
              className="tertiary-btn-small tertiary-btn-small-main"
              type="button"
              onClick={() => {}}
            >
              {paymentMethod ? "Confirm & Enroll" : "Proceed to Checkout"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollBrilliantMaxModal;
